<template>
  <div class="trainer_videos">
    <!-- <b-modal id="modal-center" centered title="BootstrapVue">
        <div>
            <p class="my-4">Vertically centered modal!</p>
        </div>
    </b-modal>
    v-b-modal.modal-center -->
    <div class="clearfix p-4">
      <div class="custom-button add-video float-right" @click="uploadVideo">
        <p>ADD +</p>
      </div>
    </div>
    <add-video
      v-if="addVideo"
      :videoData="videoData"
      @exit="closeModal"
    ></add-video>
    <div
      class="d-flex flex-column flex-fill justify-content-center align-items-center"
      v-if="totalRows > 0"
    >
      <b-table
        responsive
        :items="trainerVideoList"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        tbody-tr-class="row-class-left"
        thead-tr-class="row-class-left row-class-header"
      >
        <template v-slot:cell(radio)="row"
          ><b-form-group>
            <b-form-radio-group
              class="video-list-radio"
              id="radio-group-1"
              v-model="videoselected"
              name="radio-options"
            >
              <b-form-radio :value="row.item.id"></b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </template>
        <template v-slot:cell(Videos)="row">
          <div class="d-flex">
            <div class="video-thumbnail mr-3">
              <b-img :src="row.item.thumbnail"></b-img>
            </div>
            <span class="video-title" @click="editVideo(row)">{{
              row.item.title
            }}</span>
          </div>
        </template>
        <template v-slot:cell(Date)="row">
          {{ toDateFormatter(row.item.date) }}
        </template>
        <template v-slot:cell(avgDuration)="row">
          {{ row.item.avgDuration }}
        </template>
        <template v-slot:cell(avgAccuracy)="row">
          <div>
            {{ row.item.avgAccuracy == "NaN" ? 0 : row.item.avgAccuracy }}%
          </div>
        </template>
        <template v-slot:cell(Views)="row">
          {{ row.item.views }}
        </template>
        <!-- <template v-slot:cell(Likes)="row">
          {{ kFormatter(row.item.likes) }}
        </template> -->
        <template v-slot:cell(Actions)="row">
          <div
            class="custom-button delete-video"
            v-show="row.item.id == videoselected"
            @click="confirmDelete(row.item.id)"
          >
            <p>Delete</p>
          </div>
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <b-pagination
            size="sm"
            pills
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="my-table"
            id="perPageSelect"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <div v-if="!videoDataLoading && totalRows == 0">
      <noData class="pt-5"></noData>
    </div>

    <loader v-if="videoDataLoading || deletingVideo"></loader>
  </div>
</template>

<script>
import AddVideo from "../components/videos/AddVideo.vue";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters, mapState } = createNamespacedHelpers(
  "admin/trainerVideosView"
);
import noData from "../components/NoDataAvailable.vue";
export default {
  data: function () {
    return {
      addVideo: false,
      videoselected: "",
      perPage: 5,
      videoData: {},
      perPageOptions: [5, 10, 15],
      currentPage: 1,
      fields: [
        { key: "radio", label: "" },
        "Videos",
        "Date",
        "avgDuration",
        "avgAccuracy",
        "Views",
        // "Likes",
        { key: "Actions", label: "" },
      ],
    };
  },
  components: {
    AddVideo,
    noData,
  },

  computed: {
    ...mapGetters(["trainerVideoList"]),
    ...mapState(["videoDataLoading", "deletingVideo"]),

    totalRows() {
      return this.trainerVideoList ? this.trainerVideoList.length : 0;
    },
    radioSelected(data) {
      return data;
    },
  },
  methods: {
    ...mapActions(["loadVideos", "deleteVideo"]),

    uploadVideo() {
      this.videoData = {};
      this.addVideo = true;
    },
    confirmDelete(video) {
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to delete this video?", {
          modalClass: "confirm__modal",
          contentClass: "confirm__modal-contents",
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          cancelVariant: "light",
          okTitle: "YES",
          cancelTitle: "NO",
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deletingVideo = true;
            this.deleteVideo({ vm: this, id: video }).then(() => {
              this.deletingVideo = false;
              this.loadVideos();
            });
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    closeModal(data) {
      this.addVideo = false;
    },
    toDateFormatter(dateTime) {
      const date = new Date(dateTime);
      let day = "" + date.getDate();
      if (day.length < 2) {
        day = "0" + day;
      }
      let month = "" + (date.getMonth() + 1);
      if (month.length < 2) {
        month = "0" + month;
      }
      return day + "." + month + "." + date.getFullYear();
    },

    editVideo(video) {
      this.videoData = video.item;
      this.addVideo = true;
    },

    kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    },
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setSelectedTenant") {
        this.loadVideos();
      }
    });
  },

  beforeDestroy() {
    this.unsubscribe();
  },
  mounted() {
    this.loadVideos();
  },
};
</script>

<style lang="scss" scoped>
.form-radio-btn-col {
  width: 20px !important;
}
.video-thumbnail {
  img {
    height: 60px;
    width: 100px;
    padding: 3px;
  }
}
.trainer_videos {
  background-color: #5c6567;
  font-size: 36px;
  font-family: Kanit-Regular, Kanit;
  color: #fff;
  overflow: hidden;
}

.add-video {
  background: transparent;
  width: 100px;
}
.add-video:hover {
  background-color: #73bc44;
}
.delete-video {
  width: 80px;
  background-color: #73bc44;
  color: black;
}
.modal-video::v-deep.modal-dialog {
  background-color: #5c6567;
  font-size: 36px;
  font-family: Kanit-Regular, Kanit;
  color: #fff;
}
.v--modal-overlay .v--modal-box[data-v-40dd3b1e] {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #5c6567;
  font-size: 36px;
  font-family: Kanit-Regular, Kanit;
  color: #fff;
}
.video-title {
  cursor: pointer;
  text-align: left !important;
}
.table-class {
  color: #fff;
  font-size: 16px;
  font-family: Kanit-Regular, Kanit;
  th {
    div {
      text-align: left;
    }
  }
  td {
    text-align: left;
  }
}
</style>